<script>
    import { setContext, getContext, createEventDispatcher } from "svelte";
    import { writable } from "svelte/store";
    export let capsule = false;
    const clsPrefix = "sui-tabs";
    const items = writable([]);
    const dispatch = createEventDispatcher();
    setContext("Tabs", {
        items,
        add: (item) => {
            items.update((old) => {
                //默认选择第一个，如果后面设置了就取消第一个的选择
                if (old.length === 0) {
                    item.active = true;
                } else if (item.active) {
                    old[0].active = false;
                }
                return [...old, ...[item]];
            });
        },
        toggle: (item) => {
            const { id, active } = item;
            items.update((old) => {
                old.map((el) => (el.active = el.id === id));
                return [...old];
            });
        },
    });
    const { toggle } = getContext("Tabs");
    let x = 0;
    function handleScroll(e) {
        x = e.target.scrollLeft > 0 ? 1 : 0;
    }
</script>

<div class={clsPrefix} class:capsule={capsule}>
    <div class={`${clsPrefix}-header`}>
        <div class={`${clsPrefix}-header-mask-left`} style:opacity={x} />
        <div class={`${clsPrefix}-header-mask-right`} style:opacity={x} />
        <div
            class={`${clsPrefix}-list`}
            role="tablist"
            on:scroll={handleScroll}
        >
            {#each $items as { id, active, title, disabled }, i}
                <div
                    class={`${clsPrefix}-list-tab`}
                    class:active
                    class:disabled
                    role="tab"
                    on:click={(e) => {
                        toggle({ id, active: true });
                        e.target.scrollIntoView({
                                behavior: "smooth",
                                block:"nearest",
                                inline: "center",
                            })
                            dispatch('change',{index:i})
                    }}
                    id={`tab-${id}`}
                    aria-selected={active}
                    aria-controls={`tabpanel-${id}`}
                    tabindex="-1"
                >
                    <span>{title}</span>
                </div>
            {/each}
        </div>
    </div>

    <slot />
</div>

<style lang="less">
    @import "./tabs.less";
</style>
